// extracted by mini-css-extract-plugin
module.exports = {"title":"SecurityFeaturesSection_title__nne5z","cardContainer":"SecurityFeaturesSection_cardContainer__G5NZG","cardBox":"SecurityFeaturesSection_cardBox__MsdxD"};